import { TimesheetsApi } from 'network/Timesheet'
import * as Thunks from './thunks'
import * as Actions from './actions'

export default class Timesheets extends TimesheetsApi {
  static thunks = Thunks
  static actions = Actions
}
